<template>
    <rkm-area
        no-margin-top
        title="Encaminhamentos"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-list
                    :items="item.plano.encaminhamentos"
                    hide-filters
                    hide-pagination
                    item-cursor="default"
                >
                    <template v-slot="{item}">
                        <rkm-row>
                            <rkm-col cols="12">
                                <Item
                                    :get-value="() => item.tipo.descricao"
                                    label="Tipo"
                                />
                            </rkm-col>
                        </rkm-row>

                        <template v-if="item.tipo.id === enums.encaminhamento.ENCAMINHAMENTO_INTERSETORIAL">
                            <rkm-row>
                                <rkm-col cols="6">
                                    <Item
                                        :get-value="() => item.intersetorialInfraestrutura.unidade.nomeFantasia"
                                        label="Unidade"
                                    />
                                </rkm-col>

                                <rkm-col cols="6">
                                    <Item
                                        :get-value="() => item.intersetorialInfraestrutura.nome"
                                        label="Local de atendimento"
                                    />
                                </rkm-col>
                            </rkm-row>
                        </template>

                        <template v-else-if="item.tipo.id === enums.encaminhamento.ENCAMINHAMENTO_PARA_SERVICO_ESPECIALIZADO">
                            <rkm-row>
                                <rkm-col cols="6">
                                    <Item
                                        :get-value="() => item.servicoEspecializadoEspecialidade.nome"
                                        label="Especialidade"
                                    />
                                </rkm-col>

                                <rkm-col cols="6">
                                    <Item
                                        :get-value="() => item.servicoEspecializadoComplemento"
                                        label="Complemento"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col cols="6">
                                    <Item
                                        :get-value="() => `${formatCid(item.servicoEspecializadoCiap.codigo)} - ${item.servicoEspecializadoCiap.descricao}`"
                                        label="CIAP 2"
                                    />
                                </rkm-col>

                                <rkm-col cols="6">
                                    <Item
                                        :get-value="() => `${formatCid(item.servicoEspecializadoCid.codigo)} - ${item.servicoEspecializadoCid.nome}`"
                                        label="CID 10"
                                    />
                                </rkm-col>

                                <rkm-col cols="6">
                                    <Item
                                        :get-value="() => item.servicoEspecializadoClassificacaoRisco.descricaoEncaminhamento"
                                        label="Classificação de risco"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col cols="12">
                                    <Item
                                        :get-value="() => item.servicoEspecializadoMotivo"
                                        label="Motivo"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col cols="12">
                                    <Item
                                        :get-value="() => item.servicoEspecializadoObservacao"
                                        label="Observações"
                                    />
                                </rkm-col>
                            </rkm-row>
                        </template>
                    </template>
                </rkm-list>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import Item from '@/components/ambulatorio/atendimento/components/historico/components/item/Index'

// Enums.
import encaminhamento from '@/enums/atencao-basica/atendimento-individual/encaminhamento'

// Mixins.
import {formats} from '@/mixins'

export default {
    components: {Item},
    data: () => ({
        enums: {encaminhamento},
    }),
    mixins: [formats],
    props: {
        item: {type: Object, required: true},
    },
}
</script>